import Vue from "vue";
import store from "@/store";

// 判断当前角色当前页面是否拥有传入的权限key 适用于单个元素单个条件判断时使用
// v-permit="edit" 相当于 v-if="$route.meta.authActions.includes('edit')"
Vue.directive("permit", {
  inserted: function(el, binding, vnode) {
    // 如果是本地则直接跳出，本地默认权限全开
    const { hostname } = window.location;
    if (
      hostname == "localhost" ||
      hostname.includes("10.150") ||
      store.state.settings.userInfo.positionName === "超级管理员"
    ) {
      return;
    }
    /*
     *判断用户是否有当前按钮的操作权限，然后控制按钮是否隐藏
     */
    const pBtn = vnode.context.$route.meta.authActions || []; //当前页面拥有的权限
    const key = binding.expression; //当前权限按钮key
    if (!pBtn.includes(key)) {
      //如果没有权限就从dom中移除该按钮
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});

Vue.directive("setTab", {
  inserted: function(el, binding, vnode) {
    // 定义事件处理函数并存储在元素上
    const clickHandler = ev => {
      if (typeof ev.target.className != "string") return;
      if (
        ev.target.parentNode?.getAttribute("cache-tab-status") ||
        ev.target.getAttribute("cache-tab-status")
      ) {
        let routePath = vnode.context.$route.path;
        let current = ev.target.getAttribute("aria-controls");
        current = current?.slice(-1);
        if (current) {
          sessionStorage.setItem(`tab${routePath}`, current);
        }
      }
    };
    // 存储处理函数到元素属性
    el.__tabClickHandler__ = clickHandler;
    // 添加事件监听器
    window.addEventListener("click", clickHandler);
  },
  unbind: function(el) {
    // 从元素属性获取处理函数并移除事件
    if (el.__tabClickHandler__) {
      window.removeEventListener("click", el.__tabClickHandler__);
      delete el.__tabClickHandler__; // 清理存储的引用
    }
  }
});

Vue.directive("getTab", {
  inserted: function(el, binding, vnode) {
    /*
     *获取当前页面缓存的当前tab，并且通过回调函数返回值
     *注意：需要绑定在当前页面根元素上面，防止获取回调函数出错问题
     */
    const routePath = vnode.context.$route.path;
    const current = sessionStorage.getItem(`tab${routePath}`) || "1";
    const tabNav = vnode.elm.querySelector(".el-tabs__nav");
    // 给当前指令下的第一个el-tab_nav dom添加个属性标识
    // 防止 tab 嵌 tab 或者多个tab 也触发 tab缓存引起bug
    if (tabNav) {
      tabNav.setAttribute("cache-tab-status", "true");
    }
    if (vnode.parent.componentInstance[binding.expression]) {
      vnode.parent.componentInstance[binding.expression](current);
    }
  }
});

const converTxtToHTML = (el, binding) => {
  /*
   *把包含文件的text，转换成html，便于区分文件与内容
   */
  let resourceMap = binding.value; //文件数据
  let txt = el.innerHTML;
  let reg = /「[a-zA-Z0-9]+」/g;
  let matched = txt.match(reg); //匹配txt包含的文件名字
  let imgs = []; //当前这条txt所包含的图片
  for (let key in resourceMap) {
    let index = key.slice(-2)[0]; //获取图片索引
    index = Number(index) || 0;
    index = index ? index - 1 : 0;
    if (key.indexOf("IMAGE") > -1) {
      imgs[index] = resourceMap[key];
    }
  }
  if (!matched || !matched.length) return;
  let convered = matched.map(item => {
    if (resourceMap[item]) {
      //如果是文件，并且找到文件路径 生成标签，
      let index = imgs.indexOf(resourceMap[item]);
      if (item.indexOf("IMAGE") > -1) {
        //如果是图片 并赋值一些attr 方便查看大图组件识别
        return `<span class="link-btn" index="${
          index > -1 ? index : 0
        }" type="preview" src="${resourceMap[item]}"
          resourceMap="${imgs.join("||")}">${item}</span>`;
      } else {
        //其他文件 直接跳转下载
        return `<a class="link-btn" href="${resourceMap[item]}" target="__blank">${item}</a>`;
      }
    }
    return item;
  });
  for (let i = 0; i < matched.length; i++) {
    //替换原txt文件名为处理过的标签或者文字等
    txt = txt.replace(matched[i], convered[i]);
    txt = txt.replace(/「IMAGE\d+?」/, `图片`);
  }
  el.innerHTML = txt;
};

Vue.directive("converTxtToHTML", {
  inserted: converTxtToHTML,
  update: converTxtToHTML
});

Vue.directive("has", {
  inserted: function(el, binding, vnode) {
    /*
     *获取当前页面缓存的当前tab，并且通过回调函数返回值
     *注意：需要绑定在当前页面根元素上面，防止获取回调函数出错问题
     */
    let routePath = vnode.context.$route.path;
    let current = sessionStorage.getItem(`tab${routePath}`) || "1";
    if (vnode.parent.componentInstance[binding.expression]) {
      vnode.parent.componentInstance[binding.expression](current);
    }
  }
});
